import { Modal, ModalHeader, ModalBody } from 'reactstrap';

import { ModalStatus } from '../../../config/constants';

// Import Static Images
import ArrowUp from '../../../assets/images/icons/arrow-up-circle.svg';
import IconError from '../../../assets/images/icons/icon-error.svg';
import AppConfig from 'config/config';

interface Props {
  modalOpen: boolean;
  modalToggler: (modalOpen: boolean) => void;
  modalStatus: number;
  modalErrorMessage: string;
  transaction: any;
}

function ConfirmationModal({ modalOpen, modalToggler, modalStatus, modalErrorMessage, transaction }: Props) {
  return (
    <Modal isOpen={modalOpen} toggle={() => modalToggler(!modalOpen)} className="modal-dialog-centered">
      <div className="modal-content-wrapper">
        <ModalHeader toggle={() => modalToggler(!modalOpen)}></ModalHeader>
        <ModalBody className="text-center p-4">
          {modalStatus === ModalStatus.request && (
            <div className="w-full pb-3">
              <div className="mx-auto size-100 vc mb-15">
                <div className="spinner2"></div>
              </div>
              <h3 className="h4">Waiting for Confirmation</h3>
              <p className="text-dark-75 fw-medium">Confirm this transaction in your wallet</p>
            </div>
          )}

          {modalStatus === ModalStatus.success && (
            <div className="w-full pb-3">
              <div className="mx-auto size-100 mb-15">
                <img src={ArrowUp} alt="Arrow Up" className="img-fluid" />
              </div>
              <h3 className="h4">Transaction Submitted</h3>
              <a
                href={`${AppConfig.EXPLORER_URL}/tx/${transaction.hash}`}
                className="link-view"
                target="_blank"
                rel="noreferrer"
              >
                View on explorer
              </a>
            </div>
          )}

          {modalStatus === ModalStatus.error && (
            <div className="w-full pb-3">
              <div className="mx-auto size-100 mb-15">
                <img src={IconError} alt="Error" className="img-fluid" />
              </div>
              <h3 className="h4">Error</h3>
              <p className="text-danger fw-medium word-wrap">{modalErrorMessage}</p>
              <div className="w-full mt-4">
                <button onClick={() => modalToggler(!modalOpen)} className="btn btn-danger btn-rounded btn-sm">
                  DISMISS
                </button>
              </div>
            </div>
          )}
        </ModalBody>
      </div>
    </Modal>
  );
}

export default ConfirmationModal;
